import { render } from "./ActiveCompany.vue?vue&type=template&id=1314c61f"
import script from "./ActiveCompany.vue?vue&type=script&lang=js"
export * from "./ActiveCompany.vue?vue&type=script&lang=js"

import "./ActiveCompany.vue?vue&type=style&index=0&id=1314c61f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__